// import './firebase';
import '@fontsource/montserrat/800.css';
import '@fontsource/montserrat/800-italic.css';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import { Page } from 'containers';
import React from 'react';
import ReactDOM from 'react-dom/client';

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <BrowserRouter>
    <Page />
  </BrowserRouter>,
);
